module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-download"
  }, [_c('img', {
    attrs: {
      "src": _vm.funreport.pic.replace('animal', 'animalHD').replace('../', './')
    }
  }), _vm._v(" "), _c('router-link', {
    staticClass: "btn",
    attrs: {
      "to": '/funreport?stay=1'
    }
  }, [_vm._v("返回报告页")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/._vue-loader@9.9.5@vue-loader/lib/template-compiler.js?id=data-v-c8dfe3de!./~/._vue-loader@9.9.5@vue-loader/lib/selector.js?type=template&index=0!./src/pages/download.vue
// module id = 138
// module chunks = 2